import { Bridge } from '..';
import { canvasDafeDatUrl } from '@/utils/canvas';
import { ICallback } from './callback';

interface ISnapshot {
  type: 'snapshot'
  args: {
    callback: ICallback,
    size?: [number, number],
  }
}

export async function snapshot(b: Bridge, msg: ISnapshot) {
  // if (msg.args.size) {
  //   await new Promise(async (resolve) => {
  //     const [width, height] = msg.args.size!
  //     b.globe.setSize(width, height)
  //     await b.globe.ee.once('draw', resolve)
  //   })
  // }
  const url = canvasDafeDatUrl(b.globe.canvas.domElement)
  b.callback(msg.args.callback, [url])
  b.globe.resize()
}
